module.exports = __webpack_public_path__ + "static/media/360_survey.9ea918c2.svg";